export function scopeRowsToTeamMembers<T extends { id: string }>(
  rows: T[],
  teamMemberIds: string[] | null,
): T[] {
  if (teamMemberIds === null) return rows;

  const allowedIds = new Set(teamMemberIds);
  return rows.filter((row) => allowedIds.has(row.id));
}

export function resolveTeamMemberIds(
  isTeamLeader: boolean,
  loadedIds: string[] | null,
): string[] | null {
  return isTeamLeader ? (loadedIds ?? []) : null;
}

export function resolveAuthorizedUserIds(
  requestedUserId: string | null | undefined,
  teamMemberIds: string[] | null,
  ownUserId?: string,
): string[] | null {
  if (ownUserId) return [ownUserId];

  const hasRequestedUser = Boolean(requestedUserId && requestedUserId !== 'all');

  if (teamMemberIds !== null) {
    if (!hasRequestedUser) return teamMemberIds;
    return teamMemberIds.includes(requestedUserId as string)
      ? [requestedUserId as string]
      : [];
  }

  return hasRequestedUser ? [requestedUserId as string] : null;
}
